import React, { type ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import type { W2Burdens } from 'utils/displayHelpers/rate-settings';

type Props = {
  w2Burdens: W2Burdens;
  children: ReactElement;
  enabled?: boolean;
};

export const W2BurdensTooltip = ({ w2Burdens, children, enabled = true }: Props) => {
  if (!enabled) {
    return children;
  }

  return (
    <Tooltip
      title={
        <div style={{ margin: '4px', fontSize: '0.8rem', lineHeight: 1.4 }}>
          <div>W2 Burden Multipliers</div>
          <ul style={{ padding: '0px 8px', marginBottom: 0 }}>
            <li>
              Federal Unemployment: {w2Burdens.federal_unemployment_percent_burden_multiplier}
            </li>
            <li>Medicare: {w2Burdens.medicare_burden_multiplier}</li>
            <li>Social Security: {w2Burdens.social_security_burden_multiplier}</li>
            <li>State Unemployment: {w2Burdens.state_unemployment_percent_burden_multiplier}</li>
          </ul>
        </div>
      }
      arrow
      placement="right"
    >
      <span>{children}</span>
    </Tooltip>
  );
};
